import { CountryCode, StateCode } from 'API';

import countries from 'shared/countries.json';
import states from 'shared/states.json';

export const countryCodeResolver = (
  e: CountryCode,
) => countries.find((country) => country.code === e)?.country || e;

export const stateCodeResolver = (
  e: StateCode,
) => states.find((state) => state.code === e)?.state || e;

export const stateCodeShortResolver = (
  e: StateCode,
) => states.find((state) => state.code === e)?.abbreviation || e;
